import SelectCloud from '../../../../../app/modules/custom/accounts/datatransfer/components/select_cloud'
import SelectRegion from '../../../../../app/modules/custom/accounts/datatransfer/components/selectRegion'
import SelectTenant from '../../../../../app/modules/custom/accounts/datatransfer/components/SelectTenant'
import GetSuscriptionSelector from '../../../../../app/modules/custom/accounts/datatransfer/components/Suscriptions'
import { getInfoSelects,getInfoSelectsGlobal } from '../request/request'
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks'
import { SetCloud } from '../../../../../redux/feature/CloudSlice'
import { SetRegion } from '../../../../../redux/feature/RegionSlice'
import { SetId } from '../../../../../redux/feature/SuscriptionSlice'
import { SetNamesus } from '../../../../../redux/feature/NameSlice'
import { useEffect,useState} from 'react'
import { useAuth } from '../../../../../app/modules/auth'
import { SetPlan } from '../../../../../redux/feature/planSlice'
import { useLocation } from 'react-router-dom'
import { getListPermisos,getListPermisostenant } from '../request/request'
import { SetListPerm } from '../../../../../redux/feature/ListPermissionSlice'
import { getListTenant } from '../../../../../app/modules/ctr-r/license/request/request'
import { SetTenant } from '../../../../../redux/feature/TenantSlice'
import { SetNameTenant } from '../../../../../redux/feature/NametenantSlice'
import SelectTenantstora from '../../../../../app/modules/custom/accounts/datatransfer/components/SelectTenant_storange'
import { setFlagValue } from '../../../../../redux/feature/FlagSlice'
import "./estilos.css"


export function MenuInnerCTX() {
  
  ///////////////////
  type listsus ={
    name: String
    id:Number
  }
  type tenats = {
    id:Number, 
    Name:string, 
    Domain:string}

    type listcloud ={
      name: String
    }

    const Type = useAppSelector(state => state.CloudSlice.Type)
    const nameRegion = useAppSelector(state => state.RegionSlice.name)
    const tenant= useAppSelector(state =>state.TenantSlice.id)
    const Id = useAppSelector(state => state.SuscriptionSlice.id)
    const nameSus = useAppSelector(state => state.NameSlice.name)
    const NameTenant = useAppSelector( state => state.NametenantSlice.name)
    const{currentUser}= useAuth()
  
    const dispatch = useAppDispatch()
    const [listRegions, setlistRegions] = useState([""])
    const [listSuscripciones, setlistSuscripciones] = useState<listsus | any>()
    const [listCloud,setlistcloud]=useState<listcloud|any>()
    
    const [Tenants, setTenants] = useState<tenats[]>([])
    const [stora,setstora]= useState<any>(false)
    const storedTenantId = localStorage.getItem('tenantId');
    const storedTenantName = localStorage.getItem('tenantName');
    const storedCloud = localStorage.getItem('cloud');
    const storedSuscription = localStorage.getItem('suscription');
    const storedSuscriptionName = localStorage.getItem('suscriptionName');
  
  
    const [Info, setInfo] = useState([{
      id:0,
      name:'',
      cloud: [
        {
          name: "",
          regions: [ ]
        }
    ],
  
    }])
  
      useEffect( () => {
        if (currentUser?.ListPermiso?.includes('Tenant.list')){
            getListTenant().then(response => {
              setTenants(response.data)
              const tenantsData=response.data
              const storedTenant = tenantsData.find((tenant:any) => tenant.id.toString() === storedTenantId);
  
              if(storedTenant){
                setstora(true)
                dispatch(SetTenant(Number(storedTenantId)))
                dispatch(SetNameTenant(String(storedTenantName)))
              }
              //SetTenant(1)
              else if (response.data.length > 0) {
                dispatch(SetTenant(response.data[0].id))
                dispatch(SetNameTenant(response.data[0].Name))
              }
          })}
          else{
  
            if(storedSuscription!==null){
              setstora(true)
              
              dispatch(SetId(Number(storedSuscription)))
            }
            //SetTenant(1)
            else if(storedSuscription===null){
              dispatch(SetId(Info[0].id))
            }
          }
  
          
          //props.setPeriodBill(mesactualstring)
       }, [tenant])
  
    
  
   ////////////////////////////////////////////////////////
    useEffect(() => {
      if (!storedTenantName&&!storedTenantId &&tenant === 0 &&stora===false){
        getInfoSelects().then(response => {
          if(response.data.length!==0){
            setInfo(response.data)
          }
          else{
            dispatch(SetCloud('Global'))
          }
        })
      }
      else if (!storedTenantName&&!storedTenantId &&tenant !== 0  &&stora===false){
        getInfoSelectsGlobal(tenant).then(response => {
          if(response.data.length!==0){
            setInfo(response.data)
          }
          else{
            dispatch(SetCloud('Global'))
          }
        })
      }
      else if (storedTenantName&&storedTenantId &&tenant === 0 &&stora===true){
      getInfoSelects().then(response => {
        if(response.data.length!==0){
          setInfo(response.data)
        }
        else{
          dispatch(SetCloud('Global'))
        }
      })
    }
    else if (storedTenantName&&storedTenantId &&tenant !== 0 &&stora===true){
      getInfoSelectsGlobal(Number(storedTenantId)).then(response => {
        if(response.data.length!==0){
          setInfo(response.data)
        }
        else{
          dispatch(SetCloud('Global'))
        }
  
      })
    }
    }, [stora,setInfo,tenant])
  
    /*************************Se obtiene la lista de permisos del tenant******************************* */
  
    useEffect(() => {
      if (tenant === 0){
      getListPermisos().then(response => {
        dispatch(SetListPerm(response.data))
      })
    }
    else if (tenant !== 0){
      getListPermisostenant(tenant).then(response => {
        dispatch(SetListPerm(response.data))
      })
    }
    }, [tenant])
  
    /*****************************************Suscripciónes********************************************************/
    
    useEffect(() => {
      ///cambio sus pasa a true
  
      setlistSuscripciones([])
      for (const sus of Info){
        if (sus){
          //setlistSuscripciones([...listSuscripciones,])
          setlistSuscripciones((oldArray:any)=> [...oldArray, {id:sus.id,name: sus.name}]);
        }
      }
     
      // eslint-disable-next-line
    }, [Info])
  
    
    useEffect(() => {
      if(listSuscripciones !== undefined && listSuscripciones.length >0&& storedSuscription===null){
        dispatch(SetId(listSuscripciones[0].id))
        dispatch(SetNamesus(listSuscripciones[0].name))
        dispatch(setFlagValue(false))
  
      }
      else if(storedSuscription!==null&&stora===true){
        dispatch(SetId(Number(storedSuscription)))
        dispatch(SetNamesus(String(storedSuscriptionName)))
        dispatch(setFlagValue(false))
  
      }
  
    },[listSuscripciones,dispatch,stora])
  
    /*************************************Cloud******************************/
  
    useEffect(() => {
      setlistcloud([])
      const selectedInfo = Info.find(info => info.id === Id); // Buscar la info seleccionada por el id del tenant
  
      if (selectedInfo) {
        for (const cloud of selectedInfo.cloud) {
          setlistcloud((oldArray:any) => [...oldArray, { name: cloud.name }]);
          
        }
      }
    }, [setInfo, Info,stora,Id])
  
  
    useEffect(() => {
      if (listCloud !== undefined && listCloud.length > 0&& storedCloud===null) {
        //dispatch(SetCloud(''))
        dispatch(SetCloud(listCloud[0].name));
      } 
      else if(storedCloud!==null&&stora===true){
        dispatch(SetCloud(String(storedCloud)))
      }
    },[listCloud])
  
  
    
  
    /*************************************Region******************************/
    useEffect(() => {
      setlistRegions([]);
      const selectedInfo = Info.find(info => info.id === Id); 
      if (selectedInfo) {
        for (const cloud of selectedInfo.cloud) {
          if (cloud.name===Type){
          for (const region of cloud.regions) {
            setlistRegions(oldArray => [...oldArray, region]);
          }
        }
        }
      }
    
      // eslint-disable-next-line
    }, [Id, Info,Type]);
  
  
    useEffect(() => {
      if (listRegions !== undefined && listRegions.length > 0) {
        dispatch(SetRegion(listRegions[0]));
        dispatch(setFlagValue(true))
      }
    },[listRegions])
  
  ////////////////////////////////////////////////////////////////
  

  const { pathname } = useLocation();

  return (
    <>
    <div className="row" style={{marginLeft:'25px'}}>
      <div className='col'>
        {currentUser?.ListPermiso?.includes('Tenant.list') && ( pathname.includes("/dashboard" ) || pathname.includes("/accounts/billing" )|| pathname.includes("/CTX/datatransfer" )||pathname.includes("/problemreport" ) 
        ||pathname.includes("/changerequest" )||pathname.includes("/featurerequest" )||pathname.includes("/CTX/troubleshooting" ) ||pathname.includes("/accounts/users" )||pathname.includes("/accounts/roles" )||pathname.includes("/CTX-R/License" )||pathname.includes("/support/SeeRequest")||pathname.includes("CTX/addBPGSegment" )||pathname.includes("CTX/addIPSecSegment" )
        ||pathname.includes("/accounts/subscriptions")||pathname.includes("/CTX-R/Addctx")||pathname.includes("/CTX-R/neighbors")||pathname.includes("/CTX-R/trobleshooting")||pathname.includes("/monitoring")||pathname.includes("/Entitlement")||pathname.includes("/FortinetDevices")
        ||pathname.includes("/EdgeConnector")||pathname.includes("/CreateLicense")) 
        &&<SelectTenantstora></SelectTenantstora>}
      </div>

      <div className='col'>

{( pathname.includes("/dashboard" ) || pathname.includes("/accounts/billing" )|| pathname.includes("/CTX/datatransfer" )||pathname.includes("/problemreport" ) 
  ||pathname.includes("/changerequest" )||pathname.includes("/featurerequest" )||pathname.includes("/CTX/troubleshooting" )||pathname.includes("CTX/addBPGSegment" )||pathname.includes("CTX/addIPSecSegment" )||pathname.includes("/CTX-R/License" )
  ||pathname.includes("/CTX-R/Addctx")||pathname.includes("/CTX-R/neighbors")||pathname.includes("/CTX-R/trobleshooting") ||pathname.includes("/monitoring")
  ||pathname.includes("/Entitlement")||pathname.includes("/FortinetDevices") ||pathname.includes("/EdgeConnector")||pathname.includes("/CreateLicense")) &&
  <GetSuscriptionSelector sus={listSuscripciones} />}
  </div>

      <div className='col'>

        {( pathname.includes("/dashboard" ) || pathname.includes("/accounts/billing" )|| pathname.includes("/CTX/datatransfer" )||pathname.includes("/problemreport" ) 
          ||pathname.includes("/changerequest" )||pathname.includes("/featurerequest" )||pathname.includes("/CTX/troubleshooting" )||pathname.includes("CTX/addBPGSegment" )||pathname.includes("CTX/addIPSecSegment" )||pathname.includes("/CTX-R/License" )
          ||pathname.includes("/CTX-R/Addctx")||pathname.includes("/CTX-R/neighbors")||pathname.includes("/CTX-R/trobleshooting") ||pathname.includes("/monitoring")
          ||pathname.includes("/Entitlement")||pathname.includes("/FortinetDevices")||pathname.includes("/EdgeConnector")||pathname.includes("/CreateLicense") ) &&
        <SelectCloud  info={Info}></SelectCloud>}
    </div>
    <div className='col'>

  {( pathname.includes("/dashboard" ) || pathname.includes("/accounts/billing" )|| pathname.includes("/CTX/datatransfer" )||pathname.includes("/problemreport" ) 
    ||pathname.includes("/changerequest" )||pathname.includes("/featurerequest" )||pathname.includes("/CTX/troubleshooting" )||pathname.includes("CTX/addBPGSegment" )||pathname.includes("CTX/addIPSecSegment" )||pathname.includes("/CTX-R/License" )
    ||pathname.includes("/CTX-R/Addctx")||pathname.includes("/CTX-R/neighbors")||pathname.includes("/CTX-R/trobleshooting") ||pathname.includes("/monitoring")
    ||pathname.includes("/Entitlement")||pathname.includes("/FortinetDevices") ||pathname.includes("/EdgeConnector")||pathname.includes("/CreateLicense"))&&
    <SelectRegion info={listRegions} />}
</div>

    
    </div>

    </>
  )
}
